import { Action } from "redux";
import { Special, ThunkAction } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./Alerts.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["GET_SPECIALS_START", "GET_SPECIALS_SUCCESS"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetSpecialsStart = ActionBase<"GET_SPECIALS_START">;
type GetSpecialsSuccess = ActionBase<"GET_SPECIALS_SUCCESS"> & {
  specials: Special[];
};

export type SpecialsAction = GetSpecialsStart | GetSpecialsSuccess;

export const isSpecialsAction = (action: Action): action is SpecialsAction =>
  isActionType(action, ActionTypeKeys);

export const getSpecials =
  (siteId: string): ThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const loadState = getState().loadStates.specials;
    if (loadState !== "unloaded" && loadState !== undefined) {
      return Promise.resolve();
    }

    dispatch(getSpecialsStart());

    try {
      const { data } = await fetch({
        dispatch,
        languageId: "de",
        authorize: false,
      }).get<Special[]>(`sites/${siteId}/specials`);
      dispatch(getSpecialsSuccess(data));
    } catch (error) {
      dispatch(
        showAlert("Beim Laden der Special-Daten ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  };

const getSpecialsStart = (): GetSpecialsStart => ({
  type: "GET_SPECIALS_START",
});

const getSpecialsSuccess = (specials: Special[]): GetSpecialsSuccess => ({
  type: "GET_SPECIALS_SUCCESS",
  specials,
});
